import React from 'react';

import { cn } from '../../../lib/utils';

/**
 * RegionHeaderItem Component
 *
 * Renders a single region header label (e.g., "FWR1", "CDR1")
 * with appropriate styling and click handling
 */

interface RegionHeaderItemProps {
  regionKey: string;
  label: string;
  isCDR: boolean;
  regionSeq: string;
  isHighlighted: boolean;
  onRegionClick?: (region: string | null) => void;
}

export const RegionHeaderItem = React.memo<RegionHeaderItemProps>(({ regionKey, label, isCDR, regionSeq, isHighlighted, onRegionClick }) => {
  const handleClick = React.useCallback(() => {
    onRegionClick?.(isHighlighted ? null : regionKey);
  }, [isHighlighted, regionKey, onRegionClick]);

  return (
    <div
      className={cn(
        'text-center transition-all cursor-pointer hover:bg-yellow-100',
        isCDR ? 'text-black font-bold' : 'text-gray-500 font-medium',
        isHighlighted && 'bg-yellow-200 text-foreground font-bold',
      )}
      style={{ width: `${regionSeq.length * 7.2}px` }}
      onClick={handleClick}
    >
      {label}
    </div>
  );
});

RegionHeaderItem.displayName = 'RegionHeaderItem';
